var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-msg f-18"},[_c('div',{staticClass:"header-style d-flex item-center"},[_c('dv-decoration-1',{staticClass:"flip-horizontal",staticStyle:{"width":"40px","height":"30px"}}),_c('div',{staticClass:"fw-800"},[_vm._v(_vm._s(_vm.msg))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }